module.exports = __webpack_public_path__ + "static/img/jiance.cb4a5220.png";